import React from 'react';
import View from "components/landing/Terms.view"

function Terms () {

    return <View />;
}

export default Terms;